import { motion } from "framer-motion";
import { EASE } from "./constants";

// Renders an array of lines with a masked line-by-line upward reveal.
export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.09, inView = false }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={inView ? { y: "0%" } : { y: "110%" }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export default MaskedLines;
